import { isPortal } from './helpers.js'

export default [
  {
    name: 'CustomerAuth',
    path: isPortal() ? '/customer' : '/portal/:account/customer',
    component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerAuthScreen.vue'),
    children: [
      {
        name: 'CustomerLogin',
        path: 'login',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerLogin.vue')
      },
      {
        name: 'CustomerRegister',
        path: 'register',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerRegister.vue')
      },
      {
        name: 'CustomerResetPassword',
        path: 'reset-password',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerResetPassword.vue')
      },
      {
        name: 'CustomerToken',
        path: 'token/:token',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerToken.vue')
      }
    ]
  },
  {
    name: 'Customer',
    path: isPortal() ? '/customer' : '/portal/:account/customer',
    component: () => import(/* webpackChunkName: "customer" */ '@/layouts/Customer.vue'),
    meta: { authCustomer: true },
    children: [
      {
        name: 'CustomerAddressList',
        path: 'addresses',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerAddressList.vue')
      },
      {
        name: 'CustomerAddressCreate',
        path: 'addresses/add',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerAddressCreate.vue')
      },
      {
        name: 'CustomerAddressEdit',
        path: 'addresses/:id',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerAddressEdit.vue')
      },
      {
        name: 'CustomerBookingList',
        path: 'bookings',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerBookingList.vue')
      },
      {
        name: 'CustomerBookingView',
        path: 'bookings/:id',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerBookingView.vue')
      },
      {
        name: 'CustomerProfile',
        path: 'profile',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/CustomerProfile.vue')
      }
    ]
  }
]